import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Grid } from "@mui/material";

export const ListItemParcedModal = ({ open, toggle, t, update, item }) => {
  const getQtyPending = () => {
    let pending = item.QTYOrdered - item.QTYConfirmed;
    if (pending < 0) return 0;
    return pending;
  };

  return (
    <Modal
      backdrop="static"
      isOpen={open}
      toggle={toggle}
      size="lg"
      style={{ maxWidth: "1000px", width: "100%" }}
      className="listItemModal"
    >
      <ModalHeader
        className="advancedSearchModal"
        style={{ background: "#000a2e", color: "white" }}
      />
      <ModalBody>
        <Grid
          container
          spacing={2}
          style={{ margin: "1rem", marginTop: ".5rem", marginBottom: "4rem" }}
          rowGap={2}
        >
          <Grid xs={12} container>
            <label className="label-euro bold fs14">
              {t("resume.itemsCollapse.parcedModal.title")}
            </label>
          </Grid>
          <Grid container alignItems="center" gap="2rem">
            <label className="label-euro bold">
              {t("resume.itemsCollapse.line")}: <span className="label-euro normal">{item.LineNo}</span>
            </label>
            <label className="label-euro bold">
              {t("resume.itemsCollapse.item")}: <span className="label-euro normal">{item.ItemNo}</span>
            </label>
            <label className="label-euro bold">
              {t("resume.itemsCollapse.description")}: <span className="label-euro normal">{item.Description}</span>
            </label>
          </Grid>
          <Grid container alignItems="center" gap="2rem">
            <Grid>
              <label className="label-euro bold">
                {t("resume.shared.qtyOrdered")}
              </label>
              <label className="label-euro">{item.QTYOrdered || 0}</label>
            </Grid>
            <Grid>
              <label className="label-euro bold">
                {t("resume.shared.qtyConfirmed")}
              </label>
              <label className="label-euro">{item.QTYConfirmed || 0}</label>
            </Grid>
            <Grid>
              <label className="label-euro bold">
                {t("resume.shared.qtyPending")}
              </label>
              <label className="label-euro">{getQtyPending() || 0}</label>
            </Grid>
          </Grid>
        </Grid>
      </ModalBody>
      <ModalFooter className="modalFooterCenter">
        <center>
          <button className="float-right custom-width-btn btn btn-primary ml-2" onClick={update}>
          {t("resume.shared.accept")}
          </button>
          <button className="float-right custom-width-btn btn btn-secondary ml-2" onClick={toggle}>
          {t("cancel")}
          </button>
        {/* <Button
            // size="small"
            // className="float-right custom-width-btn btn btn-primary ml-2"
            // variant="contained"
            // color="secondary"
            onClick={update}
          >
            {t("resume.shared.accept")}
          </Button>{" "} */}
          {/* <Button
            // style={{
            //   marginRight: "20px",
            //   color: "#000a2e",
            //   borderRadius: 20,
            // }}
            // color="primary"
            // size="small"
            // variant="contained"
            // className="float-right custom-width-btn btn btn-secondary"
            onClick={toggle}
          >
            {t("cancel")}
          </Button> */}

        </center>
      </ModalFooter>
    </Modal>
  );
};
